import { object, string, array } from 'yup';
import addUrlHasProtocolValidation from '@afosto/utils-react/validators/urlHasProtocol';
import addisValidUrlValidation from '@afosto/utils-react/validators/isValidUrl';

addUrlHasProtocolValidation();
addisValidUrlValidation();

export const editValidationSchema = object().shape({
  name: string().required(),
});

export default object().shape({
  name: string().required(),
  redirectUri: string().nullable().urlHasProtocol().validUrl(),
  grantTypes: array().required(),
  scopes: array(),
});
